import {
  AboutCompanyOverviewSection,
  AboutMissionVisionSection,
  AboutWhoWeServeSection,
  AboutJourneySection,
  AboutDifferentiatorsSection,
  AboutSafetyCommitmentSection,
  AboutCorporateResponsibilitySection,
} from "@features/residential/components";

interface AboutUsPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function AboutUsPage({ hero, footer }: AboutUsPageProps) {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      {hero}
      <AboutCompanyOverviewSection />
      <AboutMissionVisionSection />
      <AboutWhoWeServeSection />
      <AboutJourneySection />
      <AboutDifferentiatorsSection />
      <AboutSafetyCommitmentSection />
      <AboutCorporateResponsibilitySection />
      {footer}
    </div>
  );
}
